
import {  AiOutlineSafetyCertificate} from 'react-icons/ai';
import {SecurityScanOutlined,UsergroupAddOutlined } from '@ant-design/icons';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

 const Pricing = () => {
  return (
    <IconContext.Provider value={{ color: '#B2B2B2', size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Ofrecemos</PricingHeading>
          <PricingContainer>
            <PricingCard to='/'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <AiOutlineSafetyCertificate />
                </PricingCardIcon>
                <PricingCardPlan  >Consultoría</PricingCardPlan>
      
                <PricingCardFeatures>
                  <PricingCardFeature>Sistemas de Gestión ISO</PricingCardFeature>
                </PricingCardFeatures>
                {/**
                 <Button primary>ver mas</Button>
                 */}
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/' >
              <PricingCardInfo>
                <PricingCardIcon>
                  <UsergroupAddOutlined style={{fontSize: '60px'}}/>
                </PricingCardIcon>
                <PricingCardPlan>Capacitación </PricingCardPlan>
                <PricingCardPlan> & Certificación</PricingCardPlan>
                 <PricingCardFeatures>
                <PricingCardFeature>Web Design Certified Expert </PricingCardFeature>
                <PricingCardFeature>Experto certificado en protección de datos personales (PDPCE)</PricingCardFeature>
                <PricingCardFeature>Ciberseguridad basada ISO/IEC 27032:2023 Implementer</PricingCardFeature>
                </PricingCardFeatures>
                 {/**
                <Button primary>ver mas</Button>
                 */}
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/'  >{/**to='/sign-up' */}
              <PricingCardInfo>
                <PricingCardIcon>
                  <SecurityScanOutlined style={{fontSize: '60px'}} />
                </PricingCardIcon>
                <PricingCardPlan>Seguridad </PricingCardPlan>
                <PricingCardPlan> Digital</PricingCardPlan>
                <PricingCardFeatures>
                <PricingCardFeature>Redes</PricingCardFeature>
                 <PricingCardFeature>Ciberseguridad</PricingCardFeature>
                  <PricingCardFeature>Videovigilancia</PricingCardFeature>
                </PricingCardFeatures>
               
                {/**
                <Button primary>ver mas</Button>
                */}
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}

export default Pricing